import { hydrateRoot } from 'react-dom/client';
import { createLoggedOutAppContext } from '../app-context/create-logged-out-app-context.tsx';
import { createSsrAppContext } from '../app-context/create-ssr-app-context.tsx';
import { getOrSetGlobalAppContext, globalAppContext } from '../app-context/global-app-context.tsx';
import { SsrViewModel, SsrViewModelName } from '../ssr-view-model/ssr-view-model.ts';
import { renderFromSsrViewModel } from '../ssr-view-model/render-from-ssr-view-model.tsx';
import { AppContextProvider } from '../app-context/app-context.tsx';
import React from 'react';
import { hydrationCompletedAttribute } from './wait-until-hydrated.tsx';

class HydrateComponent extends HTMLElement {
  async connectedCallback(): Promise<void> {
    const viewModelName = this.getAttribute('data-view-model-name') as SsrViewModelName;
    const viewModelString = document.querySelector(
      `[data-ssr-view-model=${viewModelName}]`
    )?.textContent;

    const appContext = globalAppContext();
    if (appContext) {
      if (viewModelString) {
        const viewModel: SsrViewModel | undefined = (() => {
          try {
            return JSON.parse(viewModelString);
          } catch (e) {
            appContext.logger.error(
              `Error parsing SSR view model ${viewModelName} from value ${viewModelString}`
            );
            return undefined;
          }
        })();

        if (viewModel) {
          const hydrationAppContext = createSsrAppContext({ logger: appContext.logger });

          const ssrAppContext = getOrSetGlobalAppContext(() => createLoggedOutAppContext());

          await renderFromSsrViewModel(viewModel).then(jsx =>
            hydrateRoot(
              this,
              <AppContextProvider
                hydrationAppContext={hydrationAppContext}
                appContext={ssrAppContext}
              >
                {jsx}
              </AppContextProvider>
            )
          );

          this.setAttribute(hydrationCompletedAttribute, 'true');
        }
      } else {
        appContext.logger.error(`View model ${viewModelName} not found`);
      }
    }
  }
}

window.customElements.define('sk-hydrate', HydrateComponent);
